export default __webpack_public_path__ + "static/media/Tutorial-Step-2.5.0284cf73.jpg";